const placeholder = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAHElEQVQoFWN49erVf2IwAzGKQGpGFeINT6KDBwBhlXXk/jREFAAAAABJRU5ErkJggg=='
export default placeholder